import i18n from '@/i18n';

export const PER_PAGE_OPTIONS = [25, 50, 100];

// A function, not a module-scope const: labels call i18n.t(), so they must be re-evaluated on
// every use (from a computed) to react to a runtime locale switch.
export const getAbsenceFieldDefinitions = () => [
  {
    key: 'employee_code',
    label: i18n.t('absences.fields.employeeCode'),
  },
  {
    key: 'full_name',
    label: i18n.t('absences.fields.employeeName'),
  },
  {
    key: 'started_at',
    label: i18n.t('absences.fields.startDate'),
  },
  {
    key: 'ended_at',
    label: i18n.t('absences.fields.endDate'),
  },
  {
    key: 'duration',
    label: i18n.t('absences.fields.days'),
  },
  {
    key: 'is_paid',
    label: i18n.t('absences.fields.paid'),
  },
  {
    key: 'type',
    label: i18n.t('absences.fields.type'),
  },
  {
    key: 'status',
    label: i18n.t('absences.fields.status'),
  },
  {
    key: 'reference',
    label: i18n.t('absences.fields.reference'),
  },
];

export const ABSENCE_FIELD_KEYS = {
  EMPLOYEE_CODE: 'employee_code',
  FULL_NAME: 'full_name',
  STARTED_AT: 'started_at',
  ENDED_AT: 'ended_at',
  DURATION: 'duration',
  IS_PAID: 'is_paid',
  TYPE: 'type',
  STATUS: 'status',
  REFERENCE: 'reference',
};

export const ABSENCE_FILTER_KEYS = {
  STARTS_ON: 'starts_on',
  ENDS_ON: 'ends_on',
};
